module.exports = __webpack_public_path__ + "static/headerPeople-db4227a838a88a22bb5ffb6bcaa7c840.png";